import 'highlight.js/styles/darcula.css'
// import 'highlight.js/styles/atom-one-light.css'
import 'highlightjs-copy/styles/highlightjs-copy.css'
import hljs from 'highlight.js'
import * as CopyButtonPlugin  from 'highlightjs-copy'

hljs.addPlugin(new CopyButtonPlugin())
